import { render, staticRenderFns } from "./CustomerPrivateDataForm.vue?vue&type=template&id=0cd362a4&"
import script from "./CustomerPrivateDataForm.vue?vue&type=script&lang=js&"
export * from "./CustomerPrivateDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports